import React, { FunctionComponent, useLayoutEffect, useState } from 'react';
import { useEffect } from 'react';
import TagManager from 'react-gtm-consent-module';
import { Helmet } from 'react-helmet';
import { Button } from 'rs-emd-ui-atoms';
import { ReactComponent as LogoLgeTablet } from './../../../images/technical-error/technical-error-lge-tablet.svg';
import { ReactComponent as LogoMobile } from './../../../images/technical-error/technical-error-mobile.svg';
import { getLabel, getTagAttributes } from '../../..';
import { ITechnicalErrorPage } from '../../../models/error-pages/technical-error-page.model';
import styles from './technical-error-component.module.scss';

type TechnicalErrorPageProps = { data?: ITechnicalErrorPage };

export const TechnicalErrorPage: FunctionComponent<TechnicalErrorPageProps> = (props: TechnicalErrorPageProps) => {
  const [isCopied, setIsCopied] = useState(false);

  // tagging
  useLayoutEffect(() => {
    // GTM datalayer
    if (props.data && props.data.tagging?.gtm?.dataLayer && props.data.tagging.gtm.dataLayer.innerHtml) {
      var objArr = JSON.parse(props.data.tagging.gtm.dataLayer.innerHtml) as any[];
      objArr?.forEach((o) => {
        const tag = {
          dataLayer: o,
        };
        TagManager.dataLayer(tag);
      });
    }
  }, [props.data]);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 3000);
    }
  }, [isCopied]);

  return (
    <div className={styles['technical-error-page-wrapper']}>
      {/* Head data */}
      <Helmet>
        {props.data?.tagging?.tags?.map((sd) => {
          if (sd.name === 'script') {
            return <script {...getTagAttributes(sd.attributes)}>{sd.innerHtml}</script>;
          }
        })}
      </Helmet>

      <LogoLgeTablet className={`${styles['svg-lge-tablet']}`} title='Technical Error Logo' />
      <LogoMobile className={`${styles['svg-mobile']}`} title='Technical Error Logo' />
      <div className={styles['error-info']}>
        <p className={styles['error-timestamp']}>{getLabel(props.data?.labels, 'error_time_details')}</p>
        <p className={styles['error-title']}>{getLabel(props.data?.labels, 'title')}</p>
        <div className={styles['error-instructions']}>
          <div dangerouslySetInnerHTML={{ __html: getLabel(props.data?.labels, 'instructions') }}></div>
          <div className={styles['session-identifier-container']}>
            <p className={isCopied ? styles['copied'] : styles['not-copied']}>{getLabel(props.data?.labels, 'info_copied')}</p>
            <p className={styles['session-identifier']} onClick={copySessionIdToClipboard}>
              <b>{getLabel(props.data?.labels, 'error_code')}</b> <span>{getLabel(props.data?.labels, 'copy_code')}</span>
            </p>
          </div>
          <p>{getLabel(props.data?.labels, 'instructions_conclusion')}</p>
        </div>
        <Button href='/' isExternalLink={true} text={getLabel(props.data?.labels, 'home_cta')} />
      </div>
    </div>
  );

  function copySessionIdToClipboard() {
    //copy contents to clipboard
    navigator.clipboard.writeText(getLabel(props.data?.labels, 'error_code')).then(function () {
      setIsCopied(true);
    });

    return;
  }
};
